window.Typeahead = require('typeahead');

$('#languagePicker').change(function () {
    $.busyLoadFull("show");
    Ajax.post('/change_language/' + $('#languagePicker').val(), {})
        .then(response => {
            if (response.data.success) {
                location.reload();
                $.busyLoadFull("hide");
            } else {
                notifier.alert (faild_load_selected_lang);
                $.busyLoadFull("hide");
            }
        })
        .catch(error => {
                if (error) {
                    const response = error.response;
                    if ((response.status === 422) && (response.data.errors)) {
                        notifier.alert(response.data.errors);
                        $.busyLoadFull("hide");
                    } else {
                        notifier.alert(unknown_error_on_change_lang);
                        $.busyLoadFull("hide");
                    }
                }
            }
        )
    ;

});